import { Component, Input, OnInit } from '@angular/core';
import { ActionSheetController, AlertController, ModalController, ToastController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { Metodosui } from '../../services/metodosui';
import { firstValueFrom } from 'rxjs';
import { ComponentesGenericosComponent } from '../componentes-genericos/componentes-genericos.component';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Component({
  selector: 'app-inspeccionareaedit',
  templateUrl: './inspeccionareaedit.component.html',
  styleUrls: ['./inspeccionareaedit.component.scss'],
  standalone: false
})
export class InspeccionareaeditComponent implements OnInit {

  @Input() mode: 'add' | 'edit' = 'add';
  @Input() areaData: any = null;
  @Input() inspeccionId: number = 0;
  @Input() lugarNombre: string = '';
  @Input() areasList: any[] = [];

  currentAreaIndex: number = 0;
  areaCounts: {
    medidas: number;
    fotos: number;
    notas: number;
    totalM2: number;
    totalEstimadoMonto: number;
    cantidadNotas: number;
  } = { medidas: 0, fotos: 0, notas: 0, totalM2: 0, totalEstimadoMonto: 0, cantidadNotas: 0 };

  formData = {
    id: 0,
    area: '',
    estructura: '',
    comentario: ''
  };

  areaTypes: any[] = [];
  filteredAreas: any[] = [];
  showAreaDropdown = false;
  selectedAreas: any[] = [];

  estructuraTypes: any[] = [];
  filteredEstructuras: any[] = [];
  showEstructuraDropdown = false;
  selectedEstructuras: any[] = [];
  isSaving = false;
  currentStep = 1;
  totalSteps = 4;

  // ── Estado y Sugerencias de IA ────────────────────────────────────────────
  aiSugeridasAreas: any[] = [];
  aiSugeridasEstructuras: any[] = [];
  aiRazon: string = '';
  lastAnalyzedComentario: string = '';

  // ── Paso 4: estado del sub-menú ──────────────────────────────────────────
  subStep: '' | 'medidas' | 'fotos' | 'notas' = '';
  selectedNotaTipo: string = '';
  selectedMedidaTipo: string = '';
  areaItems: any[] = [];
  loadingItems = false;
  savedAreaId = '';
  areaSaved = false;
  hasModified = false;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosUi: Metodosui
  ) { }

  ngOnInit() {
    this.loadAreaTypes();
    this.loadEstructuraTypes();

    if (this.mode === 'edit' && this.areaData) {
      if (this.areasList && this.areasList.length > 0) {
        const foundIdx = this.areasList.findIndex(a => a.id === this.areaData.id);
        this.currentAreaIndex = foundIdx !== -1 ? foundIdx : 0;
      }
      this.populateAreaData(this.areaData);
    }
    // Cargar contadores al iniciar en modo edición
    if (this.mode === 'edit' && this.areaData) {
      this.loadAreaCounts();
    }
  }

  populateAreaData(data: any) {
    if (!data) return;
    this.areaData = data;
    this.formData.id = data.id || 0;
    this.formData.comentario = data.dt4 || data.comentario || '';
    this.savedAreaId = String(data.id || '');
    this.areaSaved = true;

    // Parse Areas (dt7: IDs, dt2: Names)
    if (data.dt7) {
      const ids = String(data.dt7).split(',');
      const names = String(data.dt2 || data.area || '').split(', ');
      this.selectedAreas = ids.map((id: string, i: number) => ({
        id: Number(id.trim()),
        nombre: names[i] ? names[i].trim() : `Area ${id}`
      }));
    } else if (data.area) {
      this.selectedAreas = [{ id: data.id, nombre: data.area }];
    } else {
      this.selectedAreas = [];
    }

    // Parse Estructuras (dt8: IDs, dt6: Names)
    if (data.dt8) {
      const ids = String(data.dt8).split(',');
      const names = String(data.dt6 || data.estructura || '').split(', ');
      this.selectedEstructuras = ids.map((id: string, i: number) => ({
        id: Number(id.trim()),
        nombre: names[i] ? names[i].trim() : `Est. ${id}`
      }));
    } else if (data.estructura) {
      this.selectedEstructuras = [{ id: 0, nombre: data.estructura }];
    } else {
      this.selectedEstructuras = [];
    }

    this.currentStep = 0;
    this.subStep = '';
    this.areaItems = [];
    this.areaCounts = { medidas: 0, fotos: 0, notas: 0, totalM2: 0, totalEstimadoMonto: 0, cantidadNotas: 0 };
    this.loadAreaCounts();
  }

  selectAreaByIndex(index: number) {
    if (!this.areasList || index < 0 || index >= this.areasList.length) return;
    this.currentAreaIndex = index;
    this.populateAreaData(this.areasList[index]);
  }

  prevRegisteredArea() {
    if (!this.areasList || this.areasList.length <= 1) return;
    const prevIdx = this.currentAreaIndex > 0 ? this.currentAreaIndex - 1 : this.areasList.length - 1;
    this.selectAreaByIndex(prevIdx);
  }

  nextRegisteredArea() {
    if (!this.areasList || this.areasList.length <= 1) return;
    const nextIdx = this.currentAreaIndex < this.areasList.length - 1 ? this.currentAreaIndex + 1 : 0;
    this.selectAreaByIndex(nextIdx);
  }

  startNewArea() {
    this.mode = 'add';
    this.areaData = null;
    this.formData = { id: 0, area: '', estructura: '', comentario: '' };
    this.selectedAreas = [];
    this.selectedEstructuras = [];
    this.savedAreaId = '';
    this.areaSaved = false;
    this.currentStep = 1;
    this.subStep = '';
    this.areaItems = [];
    this.aiSugeridasAreas = [];
    this.aiSugeridasEstructuras = [];
    this.aiRazon = '';
    this.lastAnalyzedComentario = '';
  }

  // ── Catálogos ─────────────────────────────────────────────────────────────

  async loadAreaTypes() {
    try {
      const res: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral(
            "selDtsList", "listAreas", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
          )
        )
      ) || [];
      this.areaTypes = res.map((r: any) => ({ id: Number(r.dt1), nombre: r.dt2 }));
    } catch (e) { console.error('Error loading area types', e); }
  }

  async loadEstructuraTypes() {
    try {
      const res: any = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral(
            "selDtsList", "listEstructuras", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""
          )
        )
      ) || [];
      this.estructuraTypes = res.map((r: any) => ({ id: Number(r.dt1), nombre: r.dt2 }));
    } catch (e) { console.error('Error loading structure types', e); }
  }

  // ── Selección de áreas ────────────────────────────────────────────────────

  onAreaChange(val: string) {
    const q = (val || '').toLowerCase().trim();
    if (q.length > 0) {
      this.filteredAreas = this.areaTypes.filter(t =>
        t.nombre.toLowerCase().includes(q) &&
        !this.selectedAreas.some(s => s.id === t.id)
      );
    } else {
      this.filteredAreas = this.areaTypes.filter(t =>
        !this.selectedAreas.some(s => s.id === t.id)
      );
    }
    this.showAreaDropdown = true;
  }

  selectArea(t: any) {
    if (!this.selectedAreas.some(s => s.id === t.id)) {
      this.selectedAreas.push(t);
    }
    this.formData.area = '';
    this.showAreaDropdown = false;
  }

  removeArea(index: number) {
    this.selectedAreas.splice(index, 1);
  }

  clearArea() {
    this.formData.area = '';
    this.showAreaDropdown = false;
  }

  async openAreaSelector() {
    const modal = await this.modalCtrl.create({
      component: ComponentesGenericosComponent,
      componentProps: {
        entity: 'AREA',
        title: 'Seleccionar Áreas',
        placeholder: 'Buscar áreas...',
        items: this.areaTypes,
        isMultiSelect: true,
        selectedIds: this.selectedAreas.map(a => a.id)
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.selected) {
      this.selectedAreas = Array.isArray(data.selected) ? data.selected : [data.selected];
    }
  }

  clearAllAreas() {
    this.selectedAreas = [];
  }

  // ── Selección de estructuras ──────────────────────────────────────────────

  onEstructuraChange(val: string) {
    const q = (val || '').toLowerCase().trim();
    if (q.length > 0) {
      this.filteredEstructuras = this.estructuraTypes.filter(t =>
        t.nombre.toLowerCase().includes(q) &&
        !this.selectedEstructuras.some(s => s.id === t.id)
      );
    } else {
      this.filteredEstructuras = this.estructuraTypes.filter(t =>
        !this.selectedEstructuras.some(s => s.id === t.id)
      );
    }
    this.showEstructuraDropdown = true;
  }

  selectEstructura(t: any) {
    if (!this.selectedEstructuras.some(s => s.id === t.id)) {
      this.selectedEstructuras.push(t);
    }
    this.formData.estructura = '';
    this.showEstructuraDropdown = false;
  }

  async openEstructuraSelector() {
    const modal = await this.modalCtrl.create({
      component: ComponentesGenericosComponent,
      componentProps: {
        entity: 'ESTRUCTURA',
        title: 'Seleccionar Estructuras',
        placeholder: 'Buscar estructuras...',
        items: this.estructuraTypes,
        isMultiSelect: true,
        selectedIds: this.selectedEstructuras.map(e => e.id)
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.selected) {
      this.selectedEstructuras = Array.isArray(data.selected) ? data.selected : [data.selected];
    }
  }

  clearAllEstructuras() {
    this.selectedEstructuras = [];
  }

  removeEstructura(index: number) {
    this.selectedEstructuras.splice(index, 1);
  }

  clearEstructura() {
    this.formData.estructura = '';
    this.showEstructuraDropdown = false;
  }

  closeDropdowns() {
    setTimeout(() => {
      this.showAreaDropdown = false;
      this.showEstructuraDropdown = false;
    }, 300);
  }

  // ── Crear catálogos inline ────────────────────────────────────────────────

  async createNewArea(nombre: string) {
    if (!nombre || !nombre.trim()) return;
    try {
      const payload = {
        trabajoD: { id: "0", cliente: nombre.trim() },
        trabajoP: { rutina: 'inspeccion_catalogos', subrutina: 'area_insert' },
        items: [],
        usuario: this.getUsuario()
      };
      const res: any = await firstValueFrom(this.javapiService.insertaTrabajo(payload));
      if (res && (res.success || res.id)) {
        const newItem = { id: Number(res.id), nombre: nombre.trim() };
        this.areaTypes.push(newItem);
        this.selectArea(newItem);
        const toast = await this.toastCtrl.create({ message: `Área "${nombre}" creada.`, duration: 2000, color: 'success' });
        await toast.present();
      }
    } catch (e) { console.error('Error creating area', e); }
  }

  async createNewEstructura(nombre: string) {
    if (!nombre || !nombre.trim()) return;
    try {
      const payload = {
        trabajoD: { id: "0", cliente: nombre.trim() },
        trabajoP: { rutina: 'inspeccion_catalogos', subrutina: 'estructura_insert' },
        items: [],
        usuario: this.getUsuario()
      };
      const res: any = await firstValueFrom(this.javapiService.insertaTrabajo(payload));
      if (res && (res.success || res.id)) {
        const newItem = { id: Number(res.id), nombre: nombre.trim() };
        this.estructuraTypes.push(newItem);
        this.selectEstructura(newItem);
        const toast = await this.toastCtrl.create({ message: `Estructura "${nombre}" creada.`, duration: 2000, color: 'success' });
        await toast.present();
      }
    } catch (e) { console.error('Error creating structure', e); }
  }

  // ── Navegación del wizard ─────────────────────────────────────────────────

  dismiss() {
    // Si estamos dentro de un sub-paso (medidas, fotos, notas), salir al menú principal
    if (this.subStep !== '') {
      this.exitSubStep();
      return;
    }
    // Si estamos en un paso del formulario (1, 2 o 3) y existe un área guardada o cargada, regresar al paso 0
    if (this.currentStep > 0 && (this.areaSaved || this.formData.id > 0 || (this.areasList && this.areasList.length > 0))) {
      this.currentStep = 0;
      return;
    }
    this.modalCtrl.dismiss(this.hasModified ? true : null);
  }

  isFormValid(): boolean {
    return !!(this.formData.comentario && this.formData.comentario.trim().length > 0) && this.selectedAreas.length > 0;
  }

  isAreaSelected(area: any): boolean {
    return this.selectedAreas.some(a => a.id === area.id);
  }

  toggleArea(area: any) {
    const idx = this.selectedAreas.findIndex(a => a.id === area.id);
    if (idx > -1) {
      this.selectedAreas.splice(idx, 1);
    } else {
      this.selectedAreas.push(area);
    }
  }

  isEstructuraSelected(est: any): boolean {
    return this.selectedEstructuras.some(e => e.id === est.id);
  }

  toggleEstructura(est: any) {
    const idx = this.selectedEstructuras.findIndex(e => e.id === est.id);
    if (idx > -1) {
      this.selectedEstructuras.splice(idx, 1);
    } else {
      this.selectedEstructuras.push(est);
    }
  }

  async analizarDescripcionConIa() {
    const desc = (this.formData.comentario || '').trim();
    if (!desc) return;

    if (this.areaTypes.length === 0) await this.loadAreaTypes();
    if (this.estructuraTypes.length === 0) await this.loadEstructuraTypes();

    let model = 'gemini-3.6-flash';
    let temperature = 0.2;
    let systemInstruction = 'Eres un asistente experto en tasación, construcción, remodelación y pintura para Pinturas García. Tu objetivo es analizar la descripción de un trabajo, daño o requerimiento ingresado por un inspector y determinar cuáles de las áreas y estructuras disponibles en los catálogos aplican mejor a esa descripción. Devuelve estrictamente un objeto JSON válido sin texto adicional, sin preámbulo y sin bloques de código markdown, con la siguiente estructura exacta: {"areas_sugeridas": [11, 14], "estructuras_sugeridas": [12, 13], "razon": "Breve justificación técnica de 1 línea"}. Solo incluye IDs numéricos existentes en los catálogos proporcionados.';
    let promptTemplate = 'Descripción del trabajo o problema preliminar:\n"{DESCRIPCION}"\n\nCatálogo de Áreas Disponibles:\n{AREAS_DISPONIBLES}\n\nCatálogo de Estructuras Disponibles:\n{ESTRUCTURAS_DISPONIBLES}\n\nAnaliza la descripción y determina las áreas y estructuras más adecuadas.';
    let freeAttempts = 2;
    let payAttempts = 1;
    let forcePay = false;

    try {
      const paramRes: any = await firstValueFrom(this.javapiService.getJsonParam('CONFIG_IA_INSPECCION_AREA')).catch(() => null);
      if (paramRes && paramRes.pa_json) {
        const config = typeof paramRes.pa_json === 'string' ? JSON.parse(paramRes.pa_json) : paramRes.pa_json;
        if (config.model) model = config.model;
        if (config.temperature !== undefined) temperature = Number(config.temperature);
        if (config.system_instruction) systemInstruction = config.system_instruction;
        if (config.prompt_template) promptTemplate = config.prompt_template;
        if (config.free_attempts !== undefined) freeAttempts = Number(config.free_attempts);
        if (config.pay_attempts !== undefined) payAttempts = Number(config.pay_attempts);
        if (config.force_pay !== undefined) forcePay = !!config.force_pay;
      }
    } catch (e) {
      console.warn('Error leyendo CONFIG_IA_INSPECCION_AREA, usando defaults', e);
    }

    const areasStr = JSON.stringify(this.areaTypes.map(a => ({ id: a.id, nombre: a.nombre })));
    const estructurasStr = JSON.stringify(this.estructuraTypes.map(e => ({ id: e.id, nombre: e.nombre })));

    let prompt = promptTemplate
      .replace(/{DESCRIPCION}/g, desc)
      .replace(/{AREAS_DISPONIBLES}/g, areasStr)
      .replace(/{ESTRUCTURAS_DISPONIBLES}/g, estructurasStr);

    const attemptsList: boolean[] = [];
    if (forcePay) {
      for (let i = 0; i < payAttempts; i++) attemptsList.push(true);
    } else {
      for (let i = 0; i < freeAttempts; i++) attemptsList.push(false);
      for (let i = 0; i < payAttempts; i++) attemptsList.push(true);
    }
    if (attemptsList.length === 0) attemptsList.push(false);

    let success = false;
    let aiResult: any = null;
    const totalAttempts = attemptsList.length;

    for (let idx = 0; idx < totalAttempts; idx++) {
      const usePayKey = attemptsList[idx];
      const attempt = idx + 1;
      await this.metodosUi.showLoadingPgv2(`Analizando descripción con IA (intento ${attempt}/${totalAttempts})...`);

      try {
        const res: any = await firstValueFrom(
          this.javapiService.generarAnalisisIa(prompt, {
            model,
            systemInstruction,
            temperature,
            usePayKey,
            attempt,
            totalAttempts
          })
        );

        if (res && res.success) {
          let parsedRaw: any = null;
          if (res.raw) {
            try {
              parsedRaw = JSON.parse(res.raw.replace(/```json/gi, '').replace(/```/g, '').trim());
            } catch {}
          }

          let parsedData: any = null;
          if (res.data) {
            parsedData = typeof res.data === 'string'
              ? JSON.parse(res.data.replace(/```json/gi, '').replace(/```/g, '').trim())
              : res.data;
          }

          aiResult = parsedRaw || parsedData;
          success = true;
          break;
        }
      } catch (callErr) {
        console.warn(`Intento ${attempt}/${totalAttempts} con IA fallido:`, callErr);
      }

      if (attempt < totalAttempts) {
        await new Promise(r => setTimeout(r, 600));
      }
    }

    await this.metodosUi.hideLoadingPgv2();

    if (success && aiResult) {
      this.lastAnalyzedComentario = desc;
      this.aiRazon = aiResult.razon || '';

      const rawAreas = aiResult.areas_sugeridas || aiResult.areasSugeridas || aiResult.areas;
      const rawEstructuras = aiResult.estructuras_sugeridas || aiResult.estructurasSugeridas || aiResult.estructuras;

      this.aiSugeridasAreas = this.parsearIdsDeIa(rawAreas, this.areaTypes);
      this.aiSugeridasEstructuras = this.parsearIdsDeIa(rawEstructuras, this.estructuraTypes);

      // Si no había áreas seleccionadas previamente, preseleccionamos las sugeridas
      if (this.selectedAreas.length === 0 && this.aiSugeridasAreas.length > 0) {
        this.selectedAreas = [...this.aiSugeridasAreas];
      }

      // Si no había estructuras seleccionadas previamente, preseleccionamos las sugeridas
      if (this.selectedEstructuras.length === 0 && this.aiSugeridasEstructuras.length > 0) {
        this.selectedEstructuras = [...this.aiSugeridasEstructuras];
      }

      if (this.aiSugeridasAreas.length > 0) {
        this.metodosUi.showToast('Sugerencias de áreas listas con IA', 'success');
      } else {
        this.metodosUi.showToast('La IA no detectó un área específica. Selecciónela manualmente.', 'warning');
      }
    }
  }

  /** Normaliza y asocia los IDs o nombres devueltos por la IA con los ítems del catálogo */
  private parsearIdsDeIa(valor: any, catalogo: any[]): any[] {
    if (!valor || !catalogo || catalogo.length === 0) return [];
    let itemsRaw: any[] = [];

    if (Array.isArray(valor)) {
      itemsRaw = valor;
    } else if (typeof valor === 'string') {
      const trimmed = valor.trim();
      if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) itemsRaw = parsed;
        } catch {
          itemsRaw = trimmed.slice(1, -1).split(',');
        }
      } else {
        itemsRaw = trimmed.split(',');
      }
    }

    const resultado: any[] = [];
    for (const item of itemsRaw) {
      if (item === null || item === undefined) continue;
      const num = Number(String(item).trim());
      if (!isNaN(num) && num > 0) {
        const found = catalogo.find(c => Number(c.id) === num);
        if (found && !resultado.some(r => r.id === found.id)) {
          resultado.push(found);
          continue;
        }
      }
      const strVal = String(item).trim().toLowerCase();
      if (strVal.length > 0) {
        const found = catalogo.find(c =>
          c.nombre.toLowerCase().trim() === strVal ||
          c.nombre.toLowerCase().includes(strVal) ||
          strVal.includes(c.nombre.toLowerCase())
        );
        if (found && !resultado.some(r => r.id === found.id)) {
          resultado.push(found);
        }
      }
    }
    return resultado;
  }

  async nextStep() {
    if (this.currentStep === 1) {
      if (this.mode === 'add' && !this.areaSaved && this.formData.comentario && this.formData.comentario.trim() !== this.lastAnalyzedComentario) {
        await this.analizarDescripcionConIa();
      }
      this.currentStep = 2;
      return;
    }

    if (this.currentStep === 4) {
      this.saveAndContinue();
      return;
    }

    if (this.currentStep < this.totalSteps && this.canAdvance()) {
      this.currentStep++;
    }
  }

  prevStep() {
    if (this.subStep !== '') {
      this.exitSubStep();
      return;
    }
    if (this.currentStep === 1 && this.mode === 'edit') {
      this.currentStep = 0;
      return;
    }
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  canAdvance(): boolean {
    if (this.currentStep === 0) {
      return true;
    }
    if (this.currentStep === 1) {
      return !!(this.formData.comentario && this.formData.comentario.trim().length > 0);
    }
    if (this.currentStep === 2) {
      return this.selectedAreas.length > 0;
    }
    if (this.currentStep === 3) {
      return true;
    }
    if (this.currentStep === 4) {
      return this.isFormValid();
    }
    return true;
  }

  // ── Guardado ──────────────────────────────────────────────────────────────

  /** Realiza el guardado en la BD y devuelve el id del ítem. No hace dismiss. */
  async performSave(): Promise<string | null> {
    if (!this.isFormValid()) return null;

    this.isSaving = true;
    try {
      const areaIds = this.selectedAreas.map(a => a.id).join(',');
      const estructuraIds = this.selectedEstructuras.map(e => e.id).join(',');
      // Si ya fue guardado una vez (y hay id), siempre actualizamos
      const subrutina = (this.areaSaved || this.mode === 'edit') ? 'update' : 'insert';

      const payload = {
        trabajoD: {
          id: this.formData.id.toString(),
          cliente: areaIds,
          lugar: estructuraIds,
          descripcion: this.formData.comentario,
          solicitante: this.inspeccionId.toString()
        },
        trabajoP: { rutina: 'inspeccion_areas', subrutina },
        items: [],
        usuario: this.getUsuario()
      };

      const res: any = await firstValueFrom(this.javapiService.insertaTrabajo(payload));
      if (res && (res.success || res.id)) {
        if (res.id) {
          this.formData.id = Number(res.id);
          return String(res.id);
        }
        return this.formData.id.toString();
      }
      return null;
    } catch (e) {
      console.error('Error saving item', e);
      return null;
    } finally {
      this.isSaving = false;
    }
  }

  /** Guarda y regresa al panel del ítem (paso 0) para registrar medidas, fotos y estimaciones. */
  async saveAndContinue() {
    if (this.areaSaved) {
      // Sólo actualizar los datos editados y regresar
      const id = await this.performSave();
      if (id !== null) {
        this.hasModified = true;
        this.metodosUi.showToast('Ítem actualizado correctamente', 'success');
        this.currentStep = 0;
        await this.reloadAreasList();
      } else {
        this.metodosUi.showToast('Error al actualizar el ítem. Intente de nuevo.', 'danger');
      }
      return;
    }

    const isAdd = this.mode === 'add';
    const id = await this.performSave();
    if (id !== null) {
      this.savedAreaId = id;
      this.areaSaved = true;
      this.hasModified = true;
      this.mode = 'edit'; // Cambiar a modo edición para habilitar su navegación
      this.metodosUi.showToast(isAdd ? 'Ítem guardado. Ahora puedes agregar medidas, fotos o estimaciones.' : 'Ítem actualizado correctamente', 'success');
      this.currentStep = 0;
      await this.reloadAreasList();
    } else {
      this.metodosUi.showToast('Error al guardar el ítem. Intente de nuevo.', 'danger');
    }
  }

  /** Recarga la lista de ítems de la inspección actual directamente desde la base de datos */
  async reloadAreasList() {
    if (!this.inspeccionId) return;
    try {
      const listaTemp: any[] = await firstValueFrom(
        this.javapiService.getCommonModel(
          this.metodosGenService.setModeloGeneral(
            "genModel", "inspeccionAreas", String(this.inspeccionId), '', '', '', '', '', '', '', '', '', '', '', '', '', ''
          )
        )
      ) || [];

      this.areasList = listaTemp.map(item => ({
        id: Number(item.dt1) || 0,
        area: item.dt2 ?? 'Área sin nombre',
        estructura: item.dt3 ?? '',
        comentario: item.dt4 ?? '',
        dt1: item.dt1,
        dt2: item.dt2,
        dt3: item.dt3,
        dt4: item.dt4,
        dt6: item.dt6,
        dt7: item.dt7,
        dt8: item.dt8
      }));

      // Seleccionar el área recién guardada o la última si existe
      if (this.savedAreaId) {
        const foundIdx = this.areasList.findIndex(a => String(a.id) === String(this.savedAreaId));
        if (foundIdx !== -1) {
          this.currentAreaIndex = foundIdx;
          this.populateAreaData(this.areasList[foundIdx]);
        }
      }
    } catch (e) {
      console.error('Error al recargar lista de áreas en el modal:', e);
    }
  }

  /** Guardado directo con dismiss (mantiene compatibilidad con flujo antiguo). */
  async save() {
    if (!this.isFormValid()) {
      this.metodosUi.showToast('Por favor seleccione al menos un área.', 'warning');
      return;
    }

    const id = await this.performSave();
    if (id !== null) {
      this.hasModified = true;
      this.metodosUi.showToast('Datos guardados correctamente', 'success');
      this.modalCtrl.dismiss(true);
    }
  }

  /** Cierra el wizard indicando que se guardó algo. */
  finalizar() {
    this.modalCtrl.dismiss(this.hasModified ? true : null);
  }

  // ── Eliminación de ítem completo (modo edición) ───────────────────────────

  async deleteArea() {
    const areaId = this.savedAreaId || (this.areaData && this.areaData.id) || this.formData.id;
    if (!areaId || String(areaId) === '0') {
      this.metodosUi.showToast('No se encontró el identificador del ítem a eliminar', 'warning');
      return;
    }

    const itemTitulo = (this.formData.comentario || '').trim() || this.selectedAreas.map(a => a.nombre).join(', ') || 'este ítem';

    const confirm = await this.metodosUi.showConfirmationPgV2({
      header: 'Eliminar Ítem',
      subHeader: 'Esta acción no se puede deshacer',
      message: `¿Estás seguro de eliminar el ítem "${itemTitulo}" y todas sus medidas, fotos y estimaciones relacionadas?`,
      confirmText: 'Eliminar Ítem',
      cancelText: 'Cancelar',
      destructive: true
    });
    if (!confirm) return;

    try {
      this.isSaving = true;
      await this.metodosUi.showLoadingPgv2('Eliminando ítem...');
      const payload = {
        trabajoD: { id: String(areaId) },
        trabajoP: { rutina: 'inspeccion_areas', subrutina: 'delete' },
        items: [],
        usuario: this.getUsuario()
      };
      const res: any = await firstValueFrom(this.javapiService.insertaTrabajo(payload));
      await this.metodosUi.hideLoadingPgv2();

      if (res) {
        this.hasModified = true;
        this.metodosUi.showToast('Ítem eliminado exitosamente', 'success');

        if (this.areasList && this.areasList.length > 0) {
          this.areasList = this.areasList.filter(a => String(a.id) !== String(areaId));
          if (this.areasList.length > 0) {
            if (this.currentAreaIndex >= this.areasList.length) {
              this.currentAreaIndex = this.areasList.length - 1;
            }
            this.populateAreaData(this.areasList[this.currentAreaIndex]);
          } else {
            this.modalCtrl.dismiss(true);
          }
        } else {
          this.modalCtrl.dismiss(true);
        }
      }
    } catch (e) {
      await this.metodosUi.hideLoadingPgv2();
      console.error('Error deleting item', e);
      this.metodosUi.showToast('Error al eliminar el ítem', 'danger');
    } finally {
      this.isSaving = false;
    }
  }

  // ── Paso 4: Sub-pasos (Medidas / Fotos / Notas) ───────────────────────────

  enterSubStep(type: 'medidas' | 'fotos' | 'notas') {
    this.subStep = type;
    this.loadAreaItems(type);
  }

  exitSubStep() {
    this.subStep = '';
    this.selectedNotaTipo = '';
    this.selectedMedidaTipo = '';
    this.areaItems = [];
    this.loadAreaCounts();
  }

  async loadAreaItems(type: 'medidas' | 'fotos' | 'notas') {
    const areaId = this.savedAreaId || this.formData.id.toString();
    if (!areaId || areaId === '0') return;

    this.loadingItems = true;
    this.areaItems = [];

    try {
      if (type === 'medidas') {
        const res: any = await firstValueFrom(
          this.javapiService.getCommonModel(
            this.metodosGenService.setModeloGeneral(
              "genModel", "inspeccionMedidas", areaId, "", "", "", "", "", "", "", "", "", "", "", "", "", ""
            )
          )
        ).catch(() => []);
        this.areaItems = (res || []).map((m: any) => ({
          id: m.dt1,
          descripcion: m.dt2,
          ancho: Number(m.dt3) || 0,
          alto: Number(m.dt4) || 0,
          unidad: m.dt5,
          area: Number(m.dt6) || 0,
          cantidad: Number(m.dt8) || 1,
          tipo_medida: m.dt9 || 'cuadrada',
          foto: m.dt7 || null,
          comentario: m.dt11 || '',
          type: 'medida'
        }));

        const availableTypes = this.groupedMedidaTypes;
        if (availableTypes.length > 0) {
          const currentExists = availableTypes.some(g => g.key === this.selectedMedidaTipo);
          if (!currentExists) {
            this.selectedMedidaTipo = availableTypes[0].key;
          }
        } else {
          this.selectedMedidaTipo = '';
        }

      } else if (type === 'fotos') {
        const res: any = await firstValueFrom(
          this.javapiService.getCommonModel(
            this.metodosGenService.setModeloGeneral(
              "genModel", "inspeccionImagenesNotas", areaId, "", "", "", "", "", "", "", "", "", "", "", "", "", ""
            )
          )
        ).catch(() => []);
        this.areaItems = (res || [])
          .filter((m: any) => m.dt2 === 'IMAGEN')
          .map((m: any) => ({
            id: m.dt1,
            comentario: m.dt3,
            foto: m.dt4,
            created_at: m.dt5,
            type: 'foto',
            base64: null,
            loadingImg: true
          }));
        this.loadAreaPhotoThumbs();

      } else if (type === 'notas') {
        const res: any = await firstValueFrom(
          this.javapiService.getInspeccionEstimadosList(areaId)
        ).catch(() => []);
        this.areaItems = (res || []).map((e: any) => ({
          id: e.dt1,
          tipo: (e.dt2 || 'GENERAL').toUpperCase(),
          dias: Number(e.dt3) || 0,
          trabajadores: Number(e.dt4) || 0,
          monto_diario: Number(e.dt6) || 0,
          costo: Number(e.dt8) || 0,
          subcontratista: e.dt9,
          comentario: e.dt10,
          created_at: e.dt12,
          type: 'nota',
          isEstimado: true,
          turno: e.dt5 || 'DIURNO',
          cantidad: Number(e.dt7) || 0
        }));

        const availableTypes = this.groupedNotaTypes;
        if (availableTypes.length > 0) {
          const currentExists = availableTypes.some(g => g.key === this.selectedNotaTipo);
          if (!currentExists) {
            this.selectedNotaTipo = availableTypes[0].key;
          }
        } else {
          this.selectedNotaTipo = '';
        }
      }
    } catch (e) {
      console.error('Error loading area items', e);
    } finally {
      this.loadingItems = false;
    }
  }

  get groupedNotaTypes(): { key: string; label: string; icon: string; count: number; totalMonto: number; items: any[] }[] {
    if (this.subStep !== 'notas' || !this.areaItems || this.areaItems.length === 0) return [];

    const config: { [key: string]: { label: string; icon: string } } = {
      'MATERIAL': { label: 'Material', icon: 'cube-outline' },
      'PLANILLA': { label: 'Planilla', icon: 'people-outline' },
      'MOVILIDAD': { label: 'Movilidad', icon: 'flashlight-outline' },
      'SUBCONTRATO': { label: 'Subcontrato', icon: 'business-outline' },
      'GENERAL': { label: 'Notas', icon: 'document-text-outline' },
      'NOTA': { label: 'Notas', icon: 'document-text-outline' }
    };

    const groupsMap = new Map<string, { key: string; label: string; icon: string; count: number; totalMonto: number; items: any[] }>();

    for (const item of this.areaItems) {
      const rawTipo = (item.tipo || 'GENERAL').toUpperCase();
      const groupKey = (rawTipo === 'NOTA' || rawTipo === 'GENERAL') ? 'GENERAL' : rawTipo;
      const conf = config[groupKey] || { label: groupKey, icon: 'document-text-outline' };

      if (!groupsMap.has(groupKey)) {
        groupsMap.set(groupKey, {
          key: groupKey,
          label: conf.label,
          icon: conf.icon,
          count: 0,
          totalMonto: 0,
          items: []
        });
      }

      const group = groupsMap.get(groupKey)!;
      group.count++;
      group.totalMonto += (Number(item.costo) || 0);
      group.items.push(item);
    }

    return Array.from(groupsMap.values());
  }

  /** Retorna la suma total del costo de todas las estimaciones registradas en el área */
  get totalEstimadoArea(): number {
    if (this.areaItems && this.areaItems.length > 0) {
      const sum = this.areaItems
        .filter((item: any) => item.tipo !== 'GENERAL' && item.tipo !== 'NOTA')
        .reduce((acc: number, item: any) => acc + (Number(item.costo) || 0), 0);
      return Math.round(sum * 100) / 100;
    }
    return this.areaCounts.totalEstimadoMonto || 0;
  }

  get filteredNotaItems(): any[] {
    if (!this.selectedNotaTipo) return this.areaItems;
    if (this.selectedNotaTipo === 'GENERAL') {
      return this.areaItems.filter(i => (i.tipo === 'GENERAL' || i.tipo === 'NOTA'));
    }
    return this.areaItems.filter(i => i.tipo === this.selectedNotaTipo);
  }

  selectNotaTipo(tipoKey: string) {
    this.selectedNotaTipo = tipoKey;
  }

  get groupedMedidaTypes(): { key: string; label: string; icon: string; count: number; totalValor: number; displayUnit: string; items: any[] }[] {
    if (this.subStep !== 'medidas' || !this.areaItems || this.areaItems.length === 0) return [];

    const config: { [key: string]: { label: string; icon: string; defaultUnit: string } } = {
      'cuadrada': { label: 'Metros Cuadrados', icon: 'grid-outline', defaultUnit: 'm²' },
      'lineal': { label: 'Metros Lineales', icon: 'resize-outline', defaultUnit: 'm' },
      'unidad': { label: 'Por Unidad', icon: 'apps-outline', defaultUnit: 'pz' }
    };

    const groupsMap = new Map<string, { key: string; label: string; icon: string; count: number; totalValor: number; displayUnit: string; items: any[] }>();

    for (const item of this.areaItems) {
      const groupKey = (item.tipo_medida || 'cuadrada').toLowerCase();
      const conf = config[groupKey] || { label: groupKey, icon: 'resize-outline', defaultUnit: '' };

      if (!groupsMap.has(groupKey)) {
        groupsMap.set(groupKey, {
          key: groupKey,
          label: conf.label,
          icon: conf.icon,
          count: 0,
          totalValor: 0,
          displayUnit: this.formatDisplayUnit(item.unidad, groupKey),
          items: []
        });
      }

      const group = groupsMap.get(groupKey)!;
      group.count++;

      // Acumular total según el tipo
      if (groupKey === 'cuadrada' || groupKey === 'lineal') {
        const itemArea = Number(item.area) || (Number(item.ancho) * (Number(item.alto) || 1) * (Number(item.cantidad) || 1));
        group.totalValor += itemArea;
      } else {
        group.totalValor += (Number(item.cantidad) || 1);
      }

      group.items.push(item);
    }

    return Array.from(groupsMap.values());
  }

  get filteredMedidaItems(): any[] {
    if (!this.selectedMedidaTipo) return this.areaItems;
    return this.areaItems.filter(i => (i.tipo_medida || 'cuadrada').toLowerCase() === this.selectedMedidaTipo.toLowerCase());
  }

  selectMedidaTipo(tipoKey: string) {
    this.selectedMedidaTipo = tipoKey;
  }

  /** Abre el modal de medidas del componente existente. */
  async openAddMedida(tipo?: 'lineal' | 'cuadrada' | 'unidad') {
    const areaId = this.savedAreaId || this.formData.id.toString();
    const { InspecdatosareamedidasComponent } = await import('../inspecdatosareamedidas/inspecdatosareamedidas.component');
    const modal = await this.modalCtrl.create({
      component: InspecdatosareamedidasComponent,
      componentProps: { areaId, defaultTipo: tipo }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.saved) {
      this.hasModified = true;
      this.loadAreaItems('medidas');
      this.loadAreaCounts();
    }
  }

  /** Abre el modal de medidas para editar una existente. */
  async openEditMedida(item: any) {
    const areaId = this.savedAreaId || this.formData.id.toString();
    const { InspecdatosareamedidasComponent } = await import('../inspecdatosareamedidas/inspecdatosareamedidas.component');
    const modal = await this.modalCtrl.create({
      component: InspecdatosareamedidasComponent,
      componentProps: { areaId, medida: item }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data && data.saved) {
      this.hasModified = true;
      this.loadAreaItems('medidas');
      this.loadAreaCounts();
    }
  }

  /** Action sheet para elegir cámara o galería. */
  async openAddFoto() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar Origen',
      cssClass: 'custom-action-sheet',
      buttons: [
        {
          text: 'Cámara',
          icon: 'camera-outline',
          handler: () => { this.processAreaPhoto(CameraSource.Camera); }
        },
        {
          text: 'Galería',
          icon: 'images-outline',
          handler: () => { this.processAreaPhoto(CameraSource.Photos); }
        },
        { text: 'Cancelar', icon: 'close-outline', role: 'cancel' }
      ]
    });
    await actionSheet.present();
  }

  async processAreaPhoto(source: CameraSource | 'camera' | 'photos') {
    const camSource = source === 'photos' || source === CameraSource.Photos ? CameraSource.Photos : CameraSource.Camera;

    try {
      if (camSource === CameraSource.Photos) {
        const result = await Camera.pickImages({
          quality: 80,
          limit: 15
        });

        if (result.photos && result.photos.length > 0) {
          await this.metodosUi.showLoadingPgv2('Procesando imágenes...');
          const loadedBase64s: string[] = [];
          for (const photo of result.photos) {
            if (photo.webPath) {
              const response = await fetch(photo.webPath);
              const blob = await response.blob();
              const base64 = await this.convertBlobToBase64(blob) as string;
              const pureBase64 = base64.split(',')[1] || base64;
              loadedBase64s.push(pureBase64);
            }
          }
          await this.metodosUi.hideLoadingPgv2();

          if (loadedBase64s.length > 0) {
            await this.saveMultipleAreaFotos(loadedBase64s);
          }
        }
      } else {
        const image = await Camera.getPhoto({
          quality: 80,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: camSource
        });

        if (image && image.base64String) {
          await this.saveAreaFoto(image.base64String, '');
        }
      }
    } catch (e) {
      console.error("User cancelled or error picking photos", e);
      await this.metodosUi.hideLoadingPgv2();
    }
  }

  private convertBlobToBase64(blob: Blob): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  }

  async saveMultipleAreaFotos(base64s: string[]) {
    const areaId = this.savedAreaId || this.formData.id.toString();
    try {
      await this.metodosUi.showLoadingPgv2(`Subiendo ${base64s.length} foto(s)...`);
      for (const base64 of base64s) {
        const model = {
          usuario: this.getUsuario(),
          subrutina: 'insert',
          datos: { dt1: '0', dt2: areaId, dt3: 'IMAGEN', dt4: '', dt5: base64 }
        };
        await firstValueFrom(this.javapiService.saveInspeccionImagenNota(model));
      }
      await this.metodosUi.hideLoadingPgv2();
      this.hasModified = true;
      this.metodosUi.showToast(`${base64s.length} foto(s) guardadas`, 'success');
      this.loadAreaItems('fotos');
    } catch (e) {
      await this.metodosUi.hideLoading();
      console.error('Error saving multiple fotos', e);
      this.metodosUi.showToast('Error al guardar las fotos', 'danger');
    }
  }

  async saveAreaFoto(base64: string, comentario: string) {
    const areaId = this.savedAreaId || this.formData.id.toString();
    try {
      const model = {
        usuario: this.getUsuario(),
        subrutina: 'insert',
        datos: { dt1: '0', dt2: areaId, dt3: 'IMAGEN', dt4: comentario, dt5: base64 }
      };
      await firstValueFrom(this.javapiService.saveInspeccionImagenNota(model));
      this.hasModified = true;
      this.metodosUi.showToast('Foto guardada', 'success');
      this.loadAreaItems('fotos');
    } catch (e) {
      console.error('Error saving foto', e);
      this.metodosUi.showToast('Error al guardar la foto', 'danger');
    }
  }

  async openFotoOptions(item: any) {
    await this.metodosUi.showActionSheetPgV2({
      header: 'Opciones de Foto',
      subHeader: item.comentario || 'Evidencia fotográfica',
      buttons: [
        {
          text: item.comentario ? 'Editar Descripción' : 'Agregar Descripción',
          icon: 'pencil-outline',
          handler: () => {
            this.editFotoComentario(item);
          }
        },
        {
          text: 'Eliminar Foto',
          icon: 'trash-outline',
          role: 'destructive',
          handler: () => {
            this.deleteAreaItem(item);
          }
        },
        {
          text: 'Cancelar',
          icon: 'close-outline',
          role: 'cancel'
        }
      ]
    });
  }

  loadAreaPhotoThumbs() {
    for (const item of this.areaItems) {
      if (item.type === 'foto' && item.foto && item.foto.length > 3 && !item.base64) {
        item.loadingImg = true;
        this.javapiService.getImage(item.foto, 'path_img_inspecciones').subscribe({
          next: (res: any) => {
            if (res) {
              item.base64 = res.toString().startsWith('data:image') ? res : `data:image/jpeg;base64,${res}`;
            }
            item.loadingImg = false;
          },
          error: (err: any) => {
            console.error('Error cargando miniatura foto', err);
            item.loadingImg = false;
          }
        });
      } else {
        item.loadingImg = false;
      }
    }
  }

  async editFotoComentario(item: any) {
    const nuevoComentario = await this.metodosUi.showInputAlertPgV2({
      header: 'Editar Descripción',
      subHeader: 'Evidencia fotográfica',
      placeholder: 'Escribe una descripción...',
      type: 'textarea',
      initialValue: item.comentario || '',
      confirmText: 'Guardar',
      cancelText: 'Cancelar'
    });

    if (nuevoComentario !== null) {
      await this.updateFotoComentario(item, nuevoComentario);
    }
  }

  async updateFotoComentario(item: any, nuevoComentario: string) {
    const areaId = String(this.savedAreaId || this.formData.id || '');
    try {
      await this.metodosUi.showLoadingPgv2('Actualizando descripción...');
      const model = {
        usuario: this.getUsuario(),
        subrutina: 'update',
        datos: {
          dt1: String(item.id || '0'),
          dt2: areaId,
          dt3: 'IMAGEN',
          dt4: nuevoComentario,
          dt5: item.foto || ''
        }
      };
      await firstValueFrom(this.javapiService.saveInspeccionImagenNota(model));
      await this.metodosUi.hideLoadingPgv2();
      this.hasModified = true;
      this.metodosUi.showToast('Descripción actualizada', 'success');
      this.loadAreaItems('fotos');
    } catch (e) {
      await this.metodosUi.hideLoadingPgv2();
      console.error('Error updating photo comment', e);
      this.metodosUi.showToast('Error al actualizar descripción', 'danger');
    }
  }

  async viewAreaPhoto(item: any) {
    if (!item || !item.foto) return;

    const photos = this.areaItems.filter(i => i.type === 'foto' && i.foto);
    const imagesForSlider = photos.map(p => ({
      id: p.id,
      path: p.foto,
      source: 'inspeccion',
      texto: p.comentario || 'Foto de Inspección'
    }));

    const startIndex = photos.findIndex(p => p.id === item.id);

    const { VerimagenComponent } = await import('../verimagen/verimagen.component');
    await this.metodosUi.openModal(VerimagenComponent, {
      images: imagesForSlider.length > 0 ? imagesForSlider : [{
        path: item.foto,
        source: 'inspeccion',
        texto: item.comentario || 'Foto de Inspección'
      }],
      startIndex: startIndex >= 0 ? startIndex : 0
    });
  }

  /** Abre el modal de estimación para la categoría seleccionada (sin segment). */
  async openAddNota(tipo?: string) {
    const areaId = String(this.savedAreaId || this.formData.id || '');
    const { InspecdatosareaestimadoeditComponent } = await import('../inspecdatosareaestimadoedit/inspecdatosareaestimadoedit.component');
    const modal = await this.modalCtrl.create({
      component: InspecdatosareaestimadoeditComponent,
      componentProps: { areaId, defaultTipo: tipo || 'PLANILLA' }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) {
      this.hasModified = true;
      this.loadAreaItems('notas');
      this.loadAreaCounts();
    }
  }

  /** Abre el modal de estimación en modo edición para la categoría específica (sin segment). */
  async openEditNota(item: any) {
    const areaId = String(this.savedAreaId || this.formData.id || '');
    const { InspecdatosareaestimadoeditComponent } = await import('../inspecdatosareaestimadoedit/inspecdatosareaestimadoedit.component');
    const modal = await this.modalCtrl.create({
      component: InspecdatosareaestimadoeditComponent,
      componentProps: { areaId, estimado: item, defaultTipo: item.tipo }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data) {
      this.hasModified = true;
      this.loadAreaItems('notas');
      this.loadAreaCounts();
    }
  }

  async deleteAreaItem(item: any) {
    let header = 'Eliminar';
    let subHeader = 'Confirmación';
    let message = '¿Estás seguro de que deseas eliminar este elemento?';

    if (item.type === 'foto') {
      header = 'Eliminar Foto';
      subHeader = 'Evidencia fotográfica';
      message = item.comentario
        ? `¿Estás seguro de eliminar esta foto?\n\n📝 "${item.comentario}"\n\n⚠️ Esta acción no se puede deshacer.`
        : '¿Estás seguro de que deseas eliminar esta fotografía de la inspección?\n\n⚠️ Esta acción no se puede deshacer.';
    } else if (item.type === 'medida') {
      header = 'Eliminar Medida';
      subHeader = item.descripcion || 'Medida';
      message = '¿Estás seguro de eliminar esta medida registrada?';
    } else if (item.isEstimado) {
      header = 'Eliminar Estimación';
      subHeader = item.tipo || 'Estimación';
      message = '¿Estás seguro de eliminar este estimado?';
    }

    const confirm = await this.metodosUi.showConfirmationPgV2({
      header,
      subHeader,
      message,
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      destructive: true
    });

    if (!confirm) return;

    try {
      await this.metodosUi.showLoadingPgv2('Eliminando...');
      if (item.type === 'medida') {
        const model = {
          usuario: this.getUsuario(),
          subrutina: 'delete',
          datos: { dt1: String(item.id), dt2: '0', dt3: '', dt4: '0', dt5: '0', dt6: '', dt7: '' }
        };
        await firstValueFrom(this.javapiService.saveInspeccionMedida(model));
      } else if (item.type === 'foto') {
        const model = {
          usuario: this.getUsuario(),
          subrutina: 'delete',
          datos: { dt1: String(item.id), dt2: '0', dt3: '', dt4: '', dt5: '' }
        };
        await firstValueFrom(this.javapiService.saveInspeccionImagenNota(model));
      } else if (item.isEstimado) {
        await firstValueFrom(this.javapiService.saveInspeccionEstimado({
          subrutina: 'DELETE',
          datos: { dt1: String(item.id) }
        }));
      }
      await this.metodosUi.hideLoadingPgv2();
      this.hasModified = true;
      this.metodosUi.showToast('Eliminado correctamente', 'success');
      this.loadAreaItems(this.subStep as 'medidas' | 'fotos' | 'notas');
      this.loadAreaCounts();
    } catch (e) {
      await this.metodosUi.hideLoadingPgv2();
      console.error('Error deleting item', e);
      this.metodosUi.showToast('Error al eliminar', 'danger');
    }
  }

  // ── Carga de contadores de medidas/fotos/notas para el área activa ──────

  async loadAreaCounts() {
    const areaId = this.savedAreaId || this.formData.id.toString();
    if (!areaId || areaId === '0') {
      this.areaCounts = { medidas: 0, fotos: 0, notas: 0, totalM2: 0, totalEstimadoMonto: 0, cantidadNotas: 0 };
      return;
    }
    try {
      const [medRes, fotoRes, notaRes] = await Promise.all([
        firstValueFrom(
          this.javapiService.getCommonModel(
            this.metodosGenService.setModeloGeneral(
              "genModel", "inspeccionMedidas", areaId, "", "", "", "", "", "", "", "", "", "", "", "", "", ""
            )
          )
        ).catch(() => []),
        firstValueFrom(
          this.javapiService.getCommonModel(
            this.metodosGenService.setModeloGeneral(
              "genModel", "inspeccionImagenesNotas", areaId, "", "", "", "", "", "", "", "", "", "", "", "", "", ""
            )
          )
        ).catch(() => []),
        firstValueFrom(
          this.javapiService.getInspeccionEstimadosList(areaId)
        ).catch(() => [])
      ]);

      const sumM2 = (medRes || [])
        .filter((m: any) => m.dt9 === 'cuadrada')
        .reduce((acc: number, m: any) => acc + (Number(m.dt6) || 0), 0);

      let totalEstimadoMonto = 0;
      let cantidadNotas = 0;
      (notaRes || []).forEach((e: any) => {
        const costo = Number(e.dt8) || 0;
        const tipo = (e.dt2 || '').toUpperCase();
        if (tipo === 'GENERAL' || tipo === 'NOTA') {
          cantidadNotas++;
        } else {
          totalEstimadoMonto += costo;
        }
      });

      this.areaCounts = {
        medidas: (medRes || []).length,
        fotos: ((fotoRes || []) as any[]).filter((m: any) => m.dt2 === 'IMAGEN').length,
        notas: (notaRes || []).length,
        totalM2: Math.round(sumM2 * 100) / 100,
        totalEstimadoMonto: Math.round(totalEstimadoMonto * 100) / 100,
        cantidadNotas
      };
    } catch {
      this.areaCounts = { medidas: 0, fotos: 0, notas: 0, totalM2: 0, totalEstimadoMonto: 0, cantidadNotas: 0 };
    }
  }

  /** Abrevia y estandariza unidades para que nunca desborden las tarjetas compactas */
  private formatDisplayUnit(u: string, tipo: string): string {
    if (!u) return tipo === 'cuadrada' ? 'm²' : (tipo === 'lineal' ? 'm' : 'pz');
    const clean = u.trim().toLowerCase();

    // Pulgadas
    if (clean.includes('pulgada') || clean.startsWith('pulg') || clean.startsWith('in')) {
      return tipo === 'cuadrada' ? 'pulg²' : 'pulg';
    }
    // Pies
    if (clean.includes('pie') || clean.startsWith('ft')) {
      return tipo === 'cuadrada' ? 'pies²' : 'pies';
    }
    // Metros
    if (clean === 'm' || clean === 'ml' || clean === 'mt' || clean === 'mts' || clean === 'm2' || clean === 'm²' || clean.includes('metro')) {
      return tipo === 'cuadrada' ? 'm²' : (tipo === 'lineal' ? 'm' : u);
    }
    // Centímetros
    if (clean === 'cm' || clean === 'cm2' || clean === 'cm²' || clean.includes('centimetro')) {
      return tipo === 'cuadrada' ? 'cm²' : 'cm';
    }
    // Yardas
    if (clean.startsWith('yd') || clean.includes('yarda')) {
      return tipo === 'cuadrada' ? 'yd²' : 'yd';
    }

    if (tipo === 'cuadrada') {
      return !u.includes('²') && !u.endsWith('2') ? `${u}²` : u.replace(/2$/, '²');
    }
    return u;
  }

  /** Retorna los totales acumulados de las medidas agrupados por tipo y por unidad */
  get resumenTotalesMedidas(): {
    cuadradas: Array<{ unidad: string; total: number; count: number }>;
    lineales: Array<{ unidad: string; total: number; count: number }>;
    unidades: Array<{ unidad: string; total: number; count: number }>;
    totalRegistros: number;
    hasAny: boolean;
  } {
    const res = {
      cuadradas: [] as Array<{ unidad: string; total: number; count: number }>,
      lineales: [] as Array<{ unidad: string; total: number; count: number }>,
      unidades: [] as Array<{ unidad: string; total: number; count: number }>,
      totalRegistros: 0,
      hasAny: false
    };

    if (!this.areaItems || this.areaItems.length === 0) return res;

    const mapCuadradas = new Map<string, { total: number; count: number }>();
    const mapLineales = new Map<string, { total: number; count: number }>();
    const mapUnidades = new Map<string, { total: number; count: number }>();

    for (const m of this.areaItems) {
      if (m.type !== 'medida') continue;
      res.totalRegistros++;
      const tipo = m.tipo_medida || 'cuadrada';
      const qty = Number(m.cantidad) || 1;
      const rawUnidad = (m.unidad || '').trim();

      if (tipo === 'cuadrada') {
        const u = this.formatDisplayUnit(rawUnidad, 'cuadrada');
        let val = Number(m.area) || 0;
        if (val <= 0) {
          const w = Number(m.ancho) || 0;
          const h = Number(m.alto) || 0;
          val = h > 0 ? (w * h * qty) : (w * qty);
        }
        const curr = mapCuadradas.get(u) || { total: 0, count: 0 };
        curr.total += val;
        curr.count += 1;
        mapCuadradas.set(u, curr);
      } else if (tipo === 'lineal') {
        const u = this.formatDisplayUnit(rawUnidad, 'lineal');
        let val = Number(m.area) || 0;
        if (val <= 0) {
          const w = Number(m.ancho) || 0;
          val = w * qty;
        }
        const curr = mapLineales.get(u) || { total: 0, count: 0 };
        curr.total += val;
        curr.count += 1;
        mapLineales.set(u, curr);
      } else if (tipo === 'unidad') {
        const u = this.formatDisplayUnit(rawUnidad, 'unidad');
        const desc = (m.descripcion || '').trim();
        const comentario = (m.comentario || '').trim();
        const detalle = desc || comentario || '';
        const label = detalle ? `${u} · ${detalle}` : u;
        const val = qty;
        const curr = mapUnidades.get(label) || { total: 0, count: 0 };
        curr.total += val;
        curr.count += 1;
        mapUnidades.set(label, curr);
      }
    }

    mapCuadradas.forEach((val, unidad) => {
      res.cuadradas.push({ unidad, total: Math.round(val.total * 100) / 100, count: val.count });
    });
    mapLineales.forEach((val, unidad) => {
      res.lineales.push({ unidad, total: Math.round(val.total * 100) / 100, count: val.count });
    });
    mapUnidades.forEach((val, unidad) => {
      res.unidades.push({ unidad, total: val.total, count: val.count });
    });

    res.hasAny = res.cuadradas.length > 0 || res.lineales.length > 0 || res.unidades.length > 0;
    return res;
  }

  /** Retorna la suma total de metros cuadrados de las medidas registradas en el área */
  get totalAreaM2(): number {
    if (this.areaItems && this.areaItems.length > 0) {
      const sum = this.areaItems
        .filter((m: any) => m.type === 'medida' && m.tipo_medida === 'cuadrada')
        .reduce((acc: number, m: any) => {
          const val = Number(m.area) > 0 ? Number(m.area) : (Number(m.ancho) * (Number(m.alto) > 0 ? Number(m.alto) : 1) * (Number(m.cantidad) || 1));
          return acc + val;
        }, 0);
      return Math.round(sum * 100) / 100;
    }
    return this.areaCounts.totalM2 || 0;
  }

  // ── Utilidades ────────────────────────────────────────────────────────────

  private getUsuario(): string {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      return user.l_usuario || '';
    }
    return 'admin';
  }
}
